var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"checkin__last-call checkin__last-call--det mt-4 d-block d-md-flex align-items-center justify-content-between"},[_c('div',{staticClass:"mb-2 mb-md-0"},[_c('Icon',{staticClass:"mr-2",attrs:{"name":"infoCircle","width":"20"}}),_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }